export default __webpack_public_path__ + "static/media/BounceBack_159x150.15e6522e.png";